import type { Contact } from '@hunting-nature/shared-core/interfaces/contact-response.interface';
import { createAction, props } from '@ngrx/store';

import { prefixed } from '../../../shared/utils/factory.utils';

const action = prefixed('[Menu Contacts]');

export const MenuContactsActions = {
  contactsOpened: createAction(action('Contacts opened')),
  filterContacts: createAction(action('Filter contacts'), props<{ searchTerm: string }>()),
  contactsLoadSucceeded: createAction(action('Contacts load succeeded'), props<{ contacts: Array<Contact> }>()),
  contactsLoadFailed: createAction(action('Contacts load failed'), props<{ error: unknown }>()),
  contactMenuOpened: createAction(action('Contact menu opened'), props<{ contact: Contact }>()),
  contactMenuClosed: createAction(action('Contact menu closed')),
  updateUsername: createAction(action('Update username'), props<{ contactId: string; username: string; originalUsername: string }>()),
  updateUsernameSucceeded: createAction(action('Update username succeeded'), props<{ contactId: string }>()),
  updateUsernameFailed: createAction(action('Update username failed'), props<{ contactId: string; originalUsername: string; error: unknown }>()),
  viewUserProfile: createAction(action('View user profile'), props<{ contactId: string }>()),
  inviteNewContact: createAction(action('Invite new contact'), props<{ contactName: string; contactEmail: string }>()),
  inviteNewContactSucceeded: createAction(action('Invite new contact succeeded')),
  inviteNewContactFailed: createAction(action('Invite new contact failed'), props<{ error: unknown }>()),
  goToInviteNewContact: createAction(action('Go to invite new contact')),
  goBackToMenuFromInviteNewContact: createAction(action('Go back to menu from invite new contact')),
  goBackToContacts: createAction(action('Go back to contacts list')),
  removeUser: createAction(action('Remove user'), props<{ contactId: string }>()),
  resendInvitation: createAction(action('Resend invitation'), props<{ contactId: string }>()),
  resendInvitationSucceeded: createAction(action('Resend invitation succeeded')),
  resendInvitationFailed: createAction(action('Resend invitation failed'), props<{ error: unknown }>()),
  resendInvitationSuccessModalClosed: createAction(action('Resend invitation success modal closed')),
  deleteContact: createAction(action('Delete contact'), props<{ contactId: string }>()),
  deleteContactSucceeded: createAction(action('Delete contact succeeded'), props<{ contactId: string }>()),
  deleteContactFailed: createAction(action('Delete contact failed'), props<{ error: unknown }>()),
  deleteContactCancelled: createAction(action('Delete contact cancelled')),
  deleteContactSuccessClosed: createAction(action('Delete contact success closed')),
};
